import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import QuestionsContent from './components/QuestionsContent'
import Sidebar from '../../components/SideBar'

const Questions: React.FC = () => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <QuestionsContent />
      <Footer />
    </>
  )
}

export default Questions
